import { render, staticRenderFns } from "./FieldChatGroup.vue?vue&type=template&id=66020550&"
import script from "./FieldChatGroup.vue?vue&type=script&lang=js&"
export * from "./FieldChatGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports